<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        Mon compte
      </el-breadcrumb-item>
    </el-breadcrumb>

    <el-row
      v-if="!!voyages"
      type="flex"
    >
      <el-col :span="24">
        <el-card shadow="never">
          <template #header>
            <el-row
              align="middle"
              type="flex"
            >
              <el-col :span="12">
                <span>Mes prochains voyages</span>
              </el-col>

              <el-col
                align="right"
                :span="12"
              >
                <el-button
                  v-loading="trips.updating"
                  size="small"
                  type="primary"
                  @click="updatesTrips"
                >
                  Actualiser mes voyages
                </el-button>
              </el-col>
            </el-row>
          </template>

          <el-alert
            v-if="voyages.filter(v => v.statut.id !== 'annule').length === 0"
            :closable="false"
            effect="dark"
            show-icon
            title="Aucun voyage à venir"
            type="info"
          />

          <template v-else>
            <div
              v-for="(voyage, i) in voyages.filter(v => v.statut.id !== 'annule')"
              :key="voyage.id"
            >
              <el-row type="flex">
                <el-col :span="24">
                  <router-link
                    class="vv-trip__title is-link"
                    :to="{ name: 'Voyage', params: { id: voyage.id } }"
                  >
                    {{ voyage.libelle_voyage }}
                  </router-link>

                  <div class="vv-trip__period">
                    <template v-if="!!voyage.date_depart && !!voyage.date_retour">
                      du {{ voyage.date_depart | date }} au {{ voyage.date_retour | date }}
                    </template>

                    <template v-else-if="!!voyage.date_depart">
                      départ le {{ voyage.date_depart | date }}
                    </template>

                    <template v-else-if="!!voyage.date_retour">
                      retour le {{ voyage.date_retour | date }}
                    </template>

                    &nbsp;pour une durée de&nbsp;

                    <template v-if="!!voyage.nombre_jours && !!voyage.nombre_nuits">
                      {{ voyage.nombre_jours }} jours / {{ voyage.nombre_nuits }} nuits
                    </template>

                    <template v-else-if="!!voyage.nombre_jours">
                      {{ voyage.nombre_jours }} jours
                    </template>

                    <template v-else-if="!!voyage.nombre_nuits">
                      {{ voyage.nombre_nuits }} nuits
                    </template>
                  </div>
                </el-col>
              </el-row>

              <el-row
                :gutter="20"
                type="flex"
              >
                <el-col
                  class="vv-trip-content"
                  :xs="24"
                  :lg="12"
                >
                  <h4 class="vv-trip-content__title">
                    Mon voyage
                  </h4>

                  <el-alert
                    class="vv-trip-content__alert"
                    :closable="false"
                    effect="dark"
                    show-icon
                    :title="voyage.statut.name"
                    :type="voyage.statut.typeAlerte"
                  />

                  <p class="vv-trip-content__info">
                    <span>N° dossier&nbsp;:</span> {{ voyage.ref_dossier }}
                  </p>

                  <p class="vv-trip-content__info">
                    <span>Destination&nbsp;:</span> {{ voyage.destination }}
                  </p>

                  <p class="vv-trip-content__info">
                    <span>Ville de départ&nbsp;:</span> {{ voyage.ville_depart }}
                  </p>

                  <p
                    v-if="!!voyage.lieu_prise_en_charge && voyage.type !== 'prestation_agenceweb'"
                    class="vv-trip-content__info"
                  >
                    <span>Lieu de prise en charge&nbsp;:</span> {{ voyage.lieu_prise_en_charge }}
                  </p>

                  <p class="vv-trip-content__info">
                    <span>Nombre de participant(s)&nbsp;:</span> {{ voyage.nb_personnes }} personne(s)
                  </p>

                  <p
                    v-if="!!voyage.organisateur"
                    class="vv-trip-content__info"
                  >
                    <span>Organisateur&nbsp;:</span> {{ voyage.organisateur }}
                  </p>
                </el-col>

                <el-col
                  class="vv-trip-content"
                  :xs="24"
                  :lg="12"
                >
                  <h4 class="vv-trip-content__title">
                    Paiement
                  </h4>

                  <el-alert
                    class="vv-trip-content__alert"
                    :closable="false"
                    effect="dark"
                    show-icon
                    :title="voyage.statut_paiement.name"
                    :type="voyage.statut_paiement.typeAlerte"
                  />

                  <p class="vv-trip-content__info">
                    <span>Montant du dossier&nbsp;:</span> {{ voyage.montant_total | currency }}
                  </p>
                </el-col>
              </el-row>

              <template v-if="!!voyage.agence">
                <el-divider />

                <el-row type="flex">
                  <el-col :span="24">
                    <h4 class="vv-trip-content__title">
                      Votre agence VERDIÉ VOYAGES en charge de votre suivi&nbsp;:
                    </h4>

                    <agence
                      v-model="voyage.agence"
                      :should-hide-internet-coordinates="voyage.type === 'prestation_agenceweb'"
                    />
                  </el-col>
                </el-row>
              </template>

              <el-row type="flex">
                <el-col
                  align="center"
                  :span="24"
                >
                  <el-button
                    size="medium"
                    type="info"
                    @click="$router.push({ name: 'Voyage', params: { id: voyage.id } })"
                  >
                    VOIR LE VOYAGE
                  </el-button>
                </el-col>
              </el-row>

              <el-divider v-if="i < voyages.length - 1" />
            </div>
          </template>
        </el-card>
      </el-col>
    </el-row>

    <el-row
      v-if="!!profil"
      type="flex"
    >
      <el-col :span="24">
        <el-card shadow="never">
          <template #header>
            <el-row
              align="middle"
              type="flex"
            >
              <el-col :span="12">
                <span v-if="isGrandPublic">Mon agence</span>
                <span v-else>Une question ?</span>
              </el-col>

              <el-col
                align="right"
                :span="12"
              >
                <el-button
                  v-if="isGrandPublic"
                  size="small"
                  type="primary"
                  @click="$router.push({ name: 'Profil', hash: '#mon-agence' })"
                >
                  Modifier mon agence
                </el-button>
              </el-col>
            </el-row>
          </template>

          <el-alert
            v-if="!profil.agencePreferee"
            :closable="false"
            effect="dark"
            show-icon
            title="Aucune agence sélectionnée"
            type="info"
          />

          <agence
            v-else
            v-model="profil.agencePreferee"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// Librairies
import { mapGetters } from 'vuex'
import params from '@/services/params'

export default {
  data () {
    return {
      isGrandPublic: params.instance.isGrandPublic,
      trips: {
        updating: false
      }
    }
  },

  computed: {
    ...mapGetters(['profil', 'voyages'])
  },

  created () {
    // Démarre l'indicateur de chargement
    this.$store.commit('startLoading')

    // Récupère les données utilisées par la vue
    Promise.all([
      this.$store.dispatch('getAgences'),
      this.$store.dispatch('getUserInfos'),
      this.$store.dispatch('getVoyages', { departApres: (new Date()).toJSON().split('T')[0] })
    ])
      .finally(() => {
        // Stop l'indicateur de chargement
        this.$store.commit('stopLoading')
      })
  },

  methods: {
    updatesTrips () {
      // Démarre l'indicateur de chargement
      this.trips.updating = true

      // Actualise la liste des voyages (hard refresh)
      this.$store.dispatch('getVoyages', { departApres: (new Date()).toJSON().split('T')[0], hardRefresh: true })
        .finally(() => {
          // Stop l'indicateur de chargement
          this.trips.updating = false
        })
    }
  }
}
</script>
